import card from '~/components/molecules/m-cards/m-card-practice'

export default {
  heading: 'Tribal practices.',
  copy: 'Click on a practice to find out more about its services, specialists and work.',
  cta: [],
  collection: [card, card, card, card],
  component: 'o-list-practices-v2',
}
